import type { ApiResponse } from '@/types/api.types'
import type { SessionInfo, UserInfo, UserProfile } from '@/types/me.types'

import { apiClient, ensureValidToken } from '../client'

export class MeService {
  async getUserInfo(): Promise<UserInfo> {
    await ensureValidToken()
    const response = await apiClient.get<ApiResponse<UserInfo>>('/api/v1/me/info')

    if (response.data && response.data.data) {
      return response.data.data
    }

    throw new Error('Failed to get current user info')
  }

  async getSessions(): Promise<SessionInfo[]> {
    await ensureValidToken()
    const response = await apiClient.get<ApiResponse<SessionInfo[]>>('/api/v1/me/sessions')

    if (response.data && response.data.data) {
      return response.data.data
    }

    return []
  }

  async getProfile(): Promise<UserProfile> {
    await ensureValidToken()
    const response = await apiClient.get<ApiResponse<UserProfile>>('/api/v1/me/profile')

    if (response.data && response.data.data) {
      return response.data.data
    }

    throw new Error('Failed to get user profile')
  }

  async updateProfile(data: { nombre: string }): Promise<UserProfile> {
    await ensureValidToken()
    const response = await apiClient.put<ApiResponse<UserProfile>>('/api/v1/me/profile', data)

    if (response.data && response.data.data) {
      return response.data.data
    }

    throw new Error('Failed to update user profile')
  }
}

export const meService = new MeService()
